$('.js-play-youtube').click(function () {
	$('.js-video-popup').fadeIn();
	$('body').addClass('overflow');
	var videoId = $(this).data("link");

	window.currentVideoId = videoId;

	if (typeof YT === 'undefined' || typeof YT.Player === 'undefined') {
		// Завантажуємо скрипт YouTube Player API
		var tag = document.createElement('script');
		tag.src = 'https://www.youtube.com/player_api';
		var firstScriptTag = document.getElementsByTagName('script')[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

		window.onYouTubePlayerAPIReady = function() {
			createYouTubePlayer(window.currentVideoId);
		};
	} else {
		createYouTubePlayer(videoId);
	}
});

function createYouTubePlayer(videoId) {
	window.ytPlayer = new YT.Player('play', {
		videoId: videoId,
		playerVars: {
			rel: 0
		},
		events: {
			'onReady': function(event) {
				setTimeout(function() {
					event.target.playVideo();
				}, 1000);
			}
		}
	});
}

$('#btn__registration').click(function(event) {
	event.stopPropagation();
	$(this).blur();
	App.auth.show();
	return false;
});

$('.js-video-popup .js-close').click(function () {
	$('.js-video-popup').fadeOut();
	$('body').removeClass('overflow');

	if (window.ytPlayer && typeof window.ytPlayer.stopVideo === 'function') {
		window.ytPlayer.stopVideo();
	}

	$('.js-video-popup .play-wrap').empty();
	$('.js-video-popup .play-wrap').append('<div id="play"></div>');
	window.ytPlayer = null;
});